module.exports = __webpack_public_path__ + "static/media/af.d67a85cd.webp";